/* @flow */
import * as React from 'react';
import { useIntl } from 'react-intl';

// Utils
import { getUserId } from '@braindate/domain/lib/user/util';
import { getUserKeywords } from 'src/shared/app/user/util/userUtils';
import {
  getUsersTopicsFetched,
  getUsersTopicsIsFetching,
} from 'src/shared/domain/topic/selector/topicSelectors';

// Hooks
import { useSelector } from 'react-redux';
import useUser from 'src/shared/components/domain/user/hooks/useUser';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import type { BraindateParticipantListElement } from '../BraindateParticipants';

type Props = {
  column: BraindateParticipantListElement,
  participant: User,
  onClose: () => void,
  isTable?: boolean,
  render: (child: React.Node) => React.Node,
};

const BraindateParticipantsItem = ({
  column,
  participant,
  onClose,
  render,
}: Props) => {
  const intl = useIntl();

  const { element, title, showMobileTitle } = column;
  const { data: user, isFetching } = useUser(getUserId(participant));

  const isUsersTopicsFetching = useSelector(
    getUsersTopicsIsFetching(getUserId(participant)),
  );
  const usersTopicsFetched = useSelector(
    getUsersTopicsFetched(getUserId(participant)),
  );

  const userKeywords = !!user && !!getUserKeywords(user, intl.locale);

  const child = React.createElement(element, {
    participant: user || participant,
    isFetching:
      (isFetching || isUsersTopicsFetching) &&
      (!usersTopicsFetched || !userKeywords),
    title: showMobileTitle ? title : undefined,
    onClose,
  });

  return render(child);
};

export default React.memo<Props>(BraindateParticipantsItem);
